<script>
import { mapState, mapActions, mapMutations } from "vuex";
import {swal} from '../../../helpers/handle_error';
import AlertError from '@/components/alert_error'

export default {
  components: { AlertError },
  data() {
    return {

        //Page errors.
        errors: [],

        // datatable
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50 ,100,{value: Number.MAX_SAFE_INTEGER,text: "عرض الكل"}],
        filter: null,
        filterOn: [],
        sortBy: "name",
        sortDesc: true,
        fields: [
            {
                // A virtual column that doesn't exist in items
                label: 'التسلسل',
                key: "index",
                sortable: true,
                visible: true
            },
            {
                label: 'الاسم',
                key: "name",
                sortable: true,
                visible: true
            },
            {
                label: 'الوصف',
                key: "description",
                sortable: true,
                visible: true
            },
            {
                label: 'تاريخ الانشاء',
                key: "created_at",
                sortable: true,
                visible: true
            },
            {
                label: 'اسم المستخدم',
                key: "username",
                sortable: true,
                visible: true
            },
            {
                label: 'تفعيل الحساب',
                key: "active",
                sortable: false,
                visible: true,
                class: "col-activation-showadmin",
            },
            {
                label: 'الاجراءات',
                key: "settings",
                sortable: false,
                class: "col-setting-showadmin",
                visible: this.$store.getters['auth/getUser'].hasAnyPermission(['edit_admin', 'delete_admin'])
            },
            ],
            // infoModal
            infoModal: {
                id: 'info-modal',
                title: '',
                content: ''
            },
        };
    },

    computed: {
        ...mapState("admin", ["admins"]),
        rows() {
            return this.admins.length;
        },
    },
  
    methods: {
        ...mapMutations('admin', ['setAdmins']),
        ...mapActions("auth", ['hasAllPermission']),
        ...mapActions("admin", ['getAll', 'delete']),
        visibleFields() {
            return this.fields.filter(field => field.visible)
        },
        // Modal
        info(item, index, button) {
            this.infoModal.title = `تعديل معلومات :  ${index}`
            this.infoModal.content = item
            this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        },
        resetInfoModal() {
            this.infoModal.title = ''
            this.infoModal.content = ''
        },
        // datatable
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        fetchAll(){
            this.getAll({all:1})
            .catch(this.handleError)
        },
        handleError(error){
            alert(error)
            if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
            else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
        },
        async deleteItem(id) {
            if(await swal.confirm()){
                this.delete(id)
                .then((response)=>{
                swal.success(response.data.message)
                })
                .catch(this.handleError)
            }
        },
    },
    created(){
        this.setAdmins([])
        this.fetchAll()
    }
};
</script>

<template>

  <div class="row mt-3">
    <div class="col-12">

        <AlertError :errors="errors" />

      <!-- Header Table -->
      <div class="row mt-1">
          <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                      عرض&nbsp;:&nbsp;
                      <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm" :options="pageOptions"></b-form-select>
                      &nbsp;مدخلات
                  </label>
              </div>
          </div>
          <!-- Search dataTables -->
          <div class="col-sm-12 col-md-6">
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                      بحث&nbsp;:&nbsp;
                      <b-form-input v-model="filter" type="search" placeholder="بحث..." class="form-control form-control-sm ml-2"></b-form-input>
                  </label>
              </div>
          </div>
          <!-- End search -->
      </div>
      <!-- Table -->
      <div class="table-responsive mb-0">
          <b-table 
            class="datatables" 
            hover 
            :items="this.admins" 
            :fields="visibleFields()" 
            responsive="md" 
            :per-page="perPage" 
            :current-page="currentPage" 
            :sort-by.sync="sortBy" 
            :sort-desc.sync="sortDesc" 
            :filter="filter" 
            :filter-included-fields="filterOn" 
            @filtered="onFiltered">
            
            <!-- A virtual column -->
            <template #cell(index)="data">
                {{ data.index + 1 }}
            </template>

            <!-- A custom formatted column Active -->
            <template v-slot:cell(active)="data">
                <span class="badge p-2"  :class="[data.item.active ? 'bg-success' : 'bg-warning',]">{{ data.item.active ? ' مفعل' : 'غير مفعل'}}</span>
            </template>

            <!-- A custom formatted column Sutting -->
            <template v-slot:cell(settings)="data">
                <div class="button-items">
                    <router-link v-can="'edit_admin'" :to="{ name: 'admins.edit', params: { id: data.item.id } }">
                        <b-button class="btn-sm" variant="warning">تعديل</b-button>
                    </router-link>
                    <b-button v-can="'delete_admin'" class="btn-sm ml-1" variant="danger" title="حذف" @click="deleteItem(data.item.id)"><i class="bx bx-trash"></i></b-button>
                    <router-link v-can="'reset_password_admin'" :to="{ name: 'admins.password.reset', params: { id: data.item.id } }">
                        <b-button class="btn-sm" variant="primary" title="اعادة تعيين كلمة المرور"><i class="bx bxs-key"></i></b-button>
                    </router-link>
              </div>
            </template>

          </b-table>
      </div>
      <!-- Footer Table -->
      <div class="row">
          <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
              </div>
          </div>
      </div>

    </div>
  </div>
  
</template>